"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
function VehicleAppraisalFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800 rounded-lg">
        <p className="text-green-800 dark:text-green-200 font-default">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Submit Another Appraisal
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" rules={{
      required: "Name is required",
      minLength: {
        value: 2,
        message: "Name must be at least 2 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default">Full Name</FormLabel>
            <FormControl>
              <Input placeholder="John Doe" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="location" rules={{
      required: "Location is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default">Location</FormLabel>
            <FormControl>
              <Input placeholder="City, State" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField control={control} name="vehicle_year" rules={{
        required: "Year is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default">Vehicle Year</FormLabel>
              <FormControl>
                <Select value={field.value || ""} onValueChange={field.onChange}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select year" />
                  </SelectTrigger>
                  <SelectContent>
                    {Array.from({
                length: 30
              }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return <SelectItem key={year} value={year.toString()} data-index={i}>
                          {year}
                        </SelectItem>;
              })}
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="vehicle_make" rules={{
        required: "Make is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default">Make</FormLabel>
              <FormControl>
                <Input placeholder="Toyota, Honda, etc." {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="vehicle_model" rules={{
        required: "Model is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default">Model</FormLabel>
              <FormControl>
                <Input placeholder="Camry, Civic, etc." {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="has_title" rules={{
      required: "Please indicate if you have the title"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default">Do you have the title?</FormLabel>
            <FormControl>
              <RadioGroup value={field.value || ""} onValueChange={field.onChange}>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="yes" id="title-yes" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="title-yes" className="text-sm font-medium font-default cursor-pointer">
                    Yes
                  </label>
                </div>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="no" id="title-no" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="title-no" className="text-sm font-medium font-default cursor-pointer">
                    No
                  </label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="has_keys" rules={{
      required: "Please indicate if you have the keys"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default">Do you have the keys?</FormLabel>
            <FormControl>
              <RadioGroup value={field.value || ""} onValueChange={field.onChange}>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="yes" id="keys-yes" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="keys-yes" className="text-sm font-medium font-default cursor-pointer">
                    Yes
                  </label>
                </div>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="no" id="keys-no" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="keys-no" className="text-sm font-medium font-default cursor-pointer">
                    No
                  </label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="running_status" rules={{
      required: "Please indicate the running status"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default">Does the vehicle run?</FormLabel>
            <FormControl>
              <RadioGroup value={field.value || ""} onValueChange={field.onChange}>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="yes" id="runs-yes" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="runs-yes" className="text-sm font-medium font-default cursor-pointer">
                    Yes
                  </label>
                </div>
                <div className="flex items-center space-x-3">
                  <RadioGroupItem value="no" id="runs-no" className="size-6 ring-2 ring-offset-1" />
                  <label htmlFor="runs-no" className="text-sm font-medium font-default cursor-pointer">
                    No
                  </label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 rounded-lg">
          <p className="text-red-800 dark:text-red-200 font-default">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full" size="lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Getting Your Price...
          </> : "Get My Best Price"}
      </Button>
    </Form>;
}
export default function VehicleAppraisalForm() {
  return <section id="vehicle-appraisal-form" className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-2">
              Get Your Free Appraisal
            </h1>
            <p className="text-muted-foreground font-default">
              Fill out the form below to receive an instant quote for your vehicle.
            </p>
          </div>

          <div className="bg-card rounded-lg shadow-md p-6 md:p-8">
            <FormProvider formId="sell-my-car-form-appraisal" sectionName="vehicle-appraisal-section" defaultValues={{
            name: "",
            location: "",
            vehicle_year: "",
            vehicle_make: "",
            vehicle_model: "",
            has_title: "",
            has_keys: "",
            running_status: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2
            },
            location: {
              required: true
            },
            vehicle_year: {
              required: true
            },
            vehicle_make: {
              required: true
            },
            vehicle_model: {
              required: true
            },
            has_title: {
              required: true
            },
            has_keys: {
              required: true
            },
            running_status: {
              required: true
            }
          }} submitText="Get My Best Price" successMessage="Thank you! We'll contact you soon with your appraisal.">
              <VehicleAppraisalFormContent />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}